import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo';
import { ReplaySubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { GlobalInitService } from './services/init/global-init.service';
import { OmvizWrapperService } from './services/omviz/omviz-wrapper.service';
import { AuthService } from './shared/api-ux/authentication.service';
import { ZendeskService } from './shared/zendesk.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  timeout!: any;
  private onDestroy$ = new ReplaySubject<void>(null);

  @HostListener('window:mousemove') onMousemove() {
    this.resetTimeout();
  }

  @HostListener('window:keypress') onKeypress() {
    this.resetTimeout();
  }

  resetTimeout(): void {
    clearTimeout(this.timeout);
    this.setTimeout(environment.authConfig.frontExpirationMinutes);
  }

  setTimeout(counter: number): void {
    this.timeout = setTimeout(() => {
      counter--;
      console.log(`Session inactive in ${counter} minutes`);
      if (counter === 0) {
        window.location.reload();
      } else {
        this.setTimeout(counter);
      }
    }, 1000 * 60);
  }

  constructor(
    public globalInitService: GlobalInitService,
    private authService: AuthService,
    private matomo: MatomoTracker,
    private router: Router,
    private omvizWrapper: OmvizWrapperService,
    private zendeskService: ZendeskService
  ) {
    console.log('Version:' + environment.VERSION);
  }

  async ngOnInit(): Promise<void> {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntil(this.onDestroy$)
      )
      .subscribe((e: NavigationEnd) => {
        this.matomo.trackPageView(e.url);
        this.zendeskService.setPageSuggestions(e.url);
      });
    // if(!window.location.pathname.includes('/file')){
    await this.authService.login();
    this.omvizWrapper.init();
    this.setTimeout(environment.authConfig.frontExpirationMinutes);
    // }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
